import { useEffect, useMemo, useRef } from "react";
import { useToast } from "../components/ToastProvider";

function normalizeMessage(message) {
  return String(message || "").trim();
}

function buildToastMessage(message, details = []) {
  const primary = normalizeMessage(message);
  const fallback = Array.isArray(details)
    ? details.map(normalizeMessage).find(Boolean) || ""
    : "";

  if (primary && fallback && primary !== fallback) {
    return `${primary} ${fallback}`;
  }

  return primary || fallback;
}

export function useToastOnServiceError(message, options = {}) {
  const { title = "Request failed", details = [] } = options;
  const { showError } = useToast();
  const lastToastKeyRef = useRef("");
  const resolvedMessage = useMemo(
    () => buildToastMessage(message, details),
    [details, message]
  );

  useEffect(() => {
    if (!resolvedMessage) {
      return;
    }

    const nextKey = `${title}:${resolvedMessage}`;

    if (lastToastKeyRef.current === nextKey) {
      return;
    }

    lastToastKeyRef.current = nextKey;
    showError(resolvedMessage, { title });
  }, [resolvedMessage, showError, title]);
}
